import type { GetBrandDTO, MbcBrandContext } from "@nlc/shared-types";

/**
 * Build the read-only brand grounding the MBC agent receives from the full
 * brand returned by the backend (`GET /brands/:id`). Sent in the chat
 * `requestContext` so the AI service never needs DB access.
 */
export function mapBrandContext(brand: GetBrandDTO): MbcBrandContext {
  return {
    audience: brand.basicInformation.audience || null,
    colors: brand.colorPalette.map((color) => color.hexCode),
    description: brand.description || null,
    id: brand.id,
    industry: brand.basicInformation.industry || null,
    keywords: brand.keywords.map((keyword) => keyword.keyword),
    name: brand.name,
    typography: brand.typography.map((font) => font.family),
  };
}
